@if (routeErrorSig(); as routeError) {
  <div class="production-report-viewer__route-error">
    <h2>Unable to Open Report</h2>
    <p>{{ routeError }}</p>
    <button type="button" class="production-report-viewer__back-button" (click)="goBack()">Go Back</button>
  </div>
} @else {
  @if (routeStateSig(); as routeState) {
    <ag-shr-production-report-viewer
      [reportId]="routeState.reportId"
      [brandingId]="routeState.brandingId"
      [variables]="routeState.variables"
      [generatedAt]="routeState.generatedAt"
      [scope]="routeState.scope"
      [saveDefaultsOnApply]="routeState.saveDefaultsOnApply"
      [useStoredDefaults]="routeState.useStoredDefaults"
      [syncAppliedVariablesToRoute]="true"
      (appliedVariablesChange)="onAppliedVariablesChange($event)"
      (backToReportsList)="goBackToReportsList()"
    ></ag-shr-production-report-viewer>
  } @else {
    <div class="production-report-viewer__page-loading">
      <dx-load-panel
        [visible]="true"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="false"
        [hideOnOutsideClick]="false"
        [message]="'Opening report...'"
      ></dx-load-panel>
    </div>
  }
}
